{
  "version": "2026-10-01",
  "language": "en",
  "sourceLanguage": "arc",
  "rotationAnchorFriday": "2026-10-02",
  "editorialPolicy": "Only excerpts independently located in the Zohar corpus are included. Original-language text and exact folio provenance are retained. English is a faithful editorial translation, not an attributed modern translation. Context notes prevent a short excerpt from being read as an independent ruling.",
  "quotes": [
    {
      "id": "zohar-shabbat-01",
      "original": "כל ברכאן דלעילא ותתא ביומא שביעאה תליין",
      "english": "All blessings above and below depend on the seventh day.",
      "citation": "II 88a · Yitro",
      "volume": "II",
      "folio": "88a",
      "parasha": "Yitro",
      "topic": "blessing",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_פח_א",
          "retrievedAt": "2026-10-01T20:32:29.485Z",
          "documentSha256": "96e2138345e8424f12cba602ce7713fb400eae8f5f2ac475a46ac2779ddffdb8"
        },
        "independent": {
          "ref": "Zohar, Yitro 26:441-27:453",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Yitro%2026%3A441-27%3A453?context=0",
          "hebrewTextSha256": "3f2fb6a9d433ee1c99db9fc59ae0d556e83b9af8f8a3905cd66064ee13383eae"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-02",
      "original": "בעי לסדרא פתוריה בליליא דשבתא בנהמי ובמזוני",
      "english": "One should set one’s table on Shabbat night with bread and food.",
      "citation": "II 88a · Yitro",
      "volume": "II",
      "folio": "88a",
      "parasha": "Yitro",
      "topic": "Shabbat meals",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_פח_א",
          "retrievedAt": "2026-10-01T20:32:29.485Z",
          "documentSha256": "96e2138345e8424f12cba602ce7713fb400eae8f5f2ac475a46ac2779ddffdb8"
        },
        "independent": {
          "ref": "Zohar, Yitro 26:441-27:453",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Yitro%2026%3A441-27%3A453?context=0",
          "hebrewTextSha256": "3f2fb6a9d433ee1c99db9fc59ae0d556e83b9af8f8a3905cd66064ee13383eae"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-03",
      "original": "בעי לאתענגא בהאי יומא, ולמיכל תלת סעודתי בשבתא",
      "english": "One should delight in this day and eat three meals on Shabbat.",
      "citation": "II 88a · Yitro",
      "volume": "II",
      "folio": "88a",
      "parasha": "Yitro",
      "topic": "oneg",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_פח_א",
          "retrievedAt": "2026-10-01T20:32:29.485Z",
          "documentSha256": "96e2138345e8424f12cba602ce7713fb400eae8f5f2ac475a46ac2779ddffdb8"
        },
        "independent": {
          "ref": "Zohar, Yitro 26:441-27:453",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Yitro%2026%3A441-27%3A453?context=0",
          "hebrewTextSha256": "3f2fb6a9d433ee1c99db9fc59ae0d556e83b9af8f8a3905cd66064ee13383eae"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-04",
      "original": "ובעי לאתענגא בכלהו סעודתי, ולמחדי בכל חד וחד מנייהו",
      "english": "One should delight in all the meals and rejoice in each one.",
      "citation": "II 88a · Yitro",
      "volume": "II",
      "folio": "88a",
      "parasha": "Yitro",
      "topic": "joy at meals",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_פח_א",
          "retrievedAt": "2026-10-01T20:32:29.485Z",
          "documentSha256": "96e2138345e8424f12cba602ce7713fb400eae8f5f2ac475a46ac2779ddffdb8"
        },
        "independent": {
          "ref": "Zohar, Yitro 26:441-27:453",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Yitro%2026%3A441-27%3A453?context=0",
          "hebrewTextSha256": "3f2fb6a9d433ee1c99db9fc59ae0d556e83b9af8f8a3905cd66064ee13383eae"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-05",
      "original": "אתקינו סעודתא דמהימנותא עלאה, אתקינו סעודתא דמלכא",
      "english": "Prepare the meal of supernal faith; prepare the King’s meal.",
      "citation": "II 88b · Yitro",
      "volume": "II",
      "folio": "88b",
      "parasha": "Yitro",
      "topic": "welcoming Shabbat",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_פח_ב",
          "retrievedAt": "2026-10-01T20:32:29.754Z",
          "documentSha256": "e5ed4691421ee1af0ae950dbe45e7f4da26da421e229ac95454b7c326c47bdce"
        },
        "independent": {
          "ref": "Zohar, Yitro 27:453-464",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Yitro%2027%3A453-464?context=0",
          "hebrewTextSha256": "3390be2aadcdb98d1289fa2fd7cbbd46a907c62924bd396796898cd76507467b"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-06",
      "original": "וכלהו עלמין בחדוותא ושלימו",
      "english": "All the worlds are in joy and wholeness.",
      "citation": "II 88b · Yitro",
      "volume": "II",
      "folio": "88b",
      "parasha": "Yitro",
      "topic": "wholeness",
      "context": "The surrounding passage describes the second Shabbat meal.",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_פח_ב",
          "retrievedAt": "2026-10-01T20:32:29.754Z",
          "documentSha256": "e5ed4691421ee1af0ae950dbe45e7f4da26da421e229ac95454b7c326c47bdce"
        },
        "independent": {
          "ref": "Zohar, Yitro 27:453-464",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Yitro%2027%3A453-464?context=0",
          "hebrewTextSha256": "3390be2aadcdb98d1289fa2fd7cbbd46a907c62924bd396796898cd76507467b"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-07",
      "original": "יהבין ליה לבר נש נשמתא אחרא, נשמתא עלאה, נשמתא דכל שלימו בה כדוגמא דעלמא דאתי",
      "english": "A person is given another soul, a higher soul, containing every perfection, like the World to Come.",
      "citation": "II 88b · Yitro",
      "volume": "II",
      "folio": "88b",
      "parasha": "Yitro",
      "topic": "neshamah",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_פח_ב",
          "retrievedAt": "2026-10-01T20:32:29.754Z",
          "documentSha256": "e5ed4691421ee1af0ae950dbe45e7f4da26da421e229ac95454b7c326c47bdce"
        },
        "independent": {
          "ref": "Zohar, Yitro 27:453-464",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Yitro%2027%3A453-464?context=0",
          "hebrewTextSha256": "3390be2aadcdb98d1289fa2fd7cbbd46a907c62924bd396796898cd76507467b"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-08",
      "original": "בהדין יומא כל דינין אתכפיין ולא מתערין בעלמא",
      "english": "On this day all judgments are subdued and do not awaken in the world.",
      "citation": "II 88b · Yitro",
      "volume": "II",
      "folio": "88b",
      "parasha": "Yitro",
      "topic": "rest from judgment",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_פח_ב",
          "retrievedAt": "2026-10-01T20:32:29.754Z",
          "documentSha256": "e5ed4691421ee1af0ae950dbe45e7f4da26da421e229ac95454b7c326c47bdce"
        },
        "independent": {
          "ref": "Zohar, Yitro 27:453-464",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Yitro%2027%3A453-464?context=0",
          "hebrewTextSha256": "3390be2aadcdb98d1289fa2fd7cbbd46a907c62924bd396796898cd76507467b"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-09",
      "original": "בהדין יומא אורייתא מתעטרא בעטרין שלימין",
      "english": "On this day the Torah is crowned with perfect crowns.",
      "citation": "II 88b · Yitro",
      "volume": "II",
      "folio": "88b",
      "parasha": "Yitro",
      "topic": "Torah on Shabbat",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_פח_ב",
          "retrievedAt": "2026-10-01T20:32:29.754Z",
          "documentSha256": "e5ed4691421ee1af0ae950dbe45e7f4da26da421e229ac95454b7c326c47bdce"
        },
        "independent": {
          "ref": "Zohar, Yitro 27:453-464",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Yitro%2027%3A453-464?context=0",
          "hebrewTextSha256": "3390be2aadcdb98d1289fa2fd7cbbd46a907c62924bd396796898cd76507467b"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-10",
      "original": "וכלהו מתעטרן בנשמתין חדתין",
      "english": "All are crowned with new souls.",
      "citation": "II 135b · Terumah",
      "volume": "II",
      "folio": "135b",
      "parasha": "Terumah",
      "topic": "new souls",
      "context": "The antecedent is the holy people entering Shabbat.",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_קלה_ב",
          "retrievedAt": "2026-10-01T20:32:30.370Z",
          "documentSha256": "20595b2c6f35646ad64013d4aa85a805cc5804aef535873faa9339d4eda54a80"
        },
        "independent": {
          "ref": "Zohar, Terumah 14:164-15:173",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Terumah%2014%3A164-15%3A173?context=0",
          "hebrewTextSha256": "ee65e323b0dd3c034dd79569312419fac8c7af57799833bf3bb99dd014b88d41"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-11",
      "original": "דיתערון ברכאן עילא ותתא כחדא",
      "english": "So that blessings may awaken above and below together.",
      "citation": "II 135b · Terumah",
      "volume": "II",
      "folio": "135b",
      "parasha": "Terumah",
      "topic": "blessing",
      "context": "A purpose clause in the explanation of the Shabbat-eve blessing.",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_קלה_ב",
          "retrievedAt": "2026-10-01T20:32:30.370Z",
          "documentSha256": "20595b2c6f35646ad64013d4aa85a805cc5804aef535873faa9339d4eda54a80"
        },
        "independent": {
          "ref": "Zohar, Terumah 14:164-15:173",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Terumah%2014%3A164-15%3A173?context=0",
          "hebrewTextSha256": "ee65e323b0dd3c034dd79569312419fac8c7af57799833bf3bb99dd014b88d41"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-12",
      "original": "ואתתא בעיא בחדוה דלבא ורעותא לאדלקא בוצינא דשבת",
      "english": "A woman should light the Shabbat lamp with joy of heart and goodwill.",
      "citation": "I 48b · Bereshit",
      "volume": "I",
      "folio": "48b",
      "parasha": "Bereshit",
      "topic": "Shabbat candles",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_א_מח_ב",
          "retrievedAt": "2026-10-01T20:32:29.284Z",
          "documentSha256": "15319e7470716f5ea1bd5894d098fcb5b25a0d2985b2ee76c379216f870006f4"
        },
        "independent": {
          "ref": "Zohar, Bereshit 78:196-79:206",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Bereshit%2078%3A196-79%3A206?context=0",
          "hebrewTextSha256": "2dfccc67dc489bbe99d4e2f1dcb7f480952928d5fc6db719b7b14e7e74954387"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-13",
      "original": "שבת ליליא ויומא זכור ושמור איהו כחדא",
      "english": "Shabbat, night and day: “remember” and “guard” are one.",
      "citation": "I 48b · Bereshit",
      "volume": "I",
      "folio": "48b",
      "parasha": "Bereshit",
      "topic": "Shabbat unity",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_א_מח_ב",
          "retrievedAt": "2026-10-01T20:32:29.284Z",
          "documentSha256": "15319e7470716f5ea1bd5894d098fcb5b25a0d2985b2ee76c379216f870006f4"
        },
        "independent": {
          "ref": "Zohar, Bereshit 78:196-79:206",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Bereshit%2078%3A196-79%3A206?context=0",
          "hebrewTextSha256": "2dfccc67dc489bbe99d4e2f1dcb7f480952928d5fc6db719b7b14e7e74954387"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-14",
      "original": "יומא דשבתא חדוה איהו לכלא",
      "english": "The day of Shabbat is joy for all.",
      "citation": "II 205a · Vayakhel",
      "volume": "II",
      "folio": "205a",
      "parasha": "Vayakhel",
      "topic": "joy",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_רה_א",
          "retrievedAt": "2026-10-01T20:32:30.607Z",
          "documentSha256": "2ca3714739669fb3b33e38b093310cf324947e640e503dc87a4e00c1b112d61b"
        },
        "independent": {
          "ref": "Zohar, Vayakhel 14:195-15:206",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Vayakhel%2014%3A195-15%3A206?context=0",
          "hebrewTextSha256": "1de576115cb5e9f1d86e2d31d28bf531f8720d512d491a2d9d87cf06d2ab5223"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-15",
      "original": "ועלאין ותתאין כלהו בחדוה, ומתעטרן כלהו כחדא",
      "english": "Those above and below are all in joy, and all are crowned together.",
      "citation": "II 205a · Vayakhel",
      "volume": "II",
      "folio": "205a",
      "parasha": "Vayakhel",
      "topic": "spiritual elevation",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_רה_א",
          "retrievedAt": "2026-10-01T20:32:30.607Z",
          "documentSha256": "2ca3714739669fb3b33e38b093310cf324947e640e503dc87a4e00c1b112d61b"
        },
        "independent": {
          "ref": "Zohar, Vayakhel 14:195-15:206",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Vayakhel%2014%3A195-15%3A206?context=0",
          "hebrewTextSha256": "1de576115cb5e9f1d86e2d31d28bf531f8720d512d491a2d9d87cf06d2ab5223"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-16",
      "original": "האי יומא - יומא דנשמתין איהו ולאו יומא דגופא",
      "english": "This day is a day of souls, not a day of the body.",
      "citation": "II 205a · Vayakhel",
      "volume": "II",
      "folio": "205a",
      "parasha": "Vayakhel",
      "topic": "neshamah",
      "context": "The passage emphasizes the spiritual character of Shabbat; it does not prescribe fasting or deny the Shabbat meals.",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_רה_א",
          "retrievedAt": "2026-10-01T20:32:30.607Z",
          "documentSha256": "2ca3714739669fb3b33e38b093310cf324947e640e503dc87a4e00c1b112d61b"
        },
        "independent": {
          "ref": "Zohar, Vayakhel 14:195-15:206",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Vayakhel%2014%3A195-15%3A206?context=0",
          "hebrewTextSha256": "1de576115cb5e9f1d86e2d31d28bf531f8720d512d491a2d9d87cf06d2ab5223"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-17",
      "original": "חדוותא ונטירותא דיומא דשבתא על כלא הוא",
      "english": "The joy and protection of Shabbat are above all.",
      "citation": "III 94b · Emor",
      "volume": "III",
      "folio": "94b",
      "parasha": "Emor",
      "topic": "protection",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ג_צד_ב",
          "retrievedAt": "2026-10-01T20:32:31.095Z",
          "documentSha256": "98de6b2e4a4bf413c77bf11d5ae093bec794ef18d345bf926bcd0aabf676d1fc"
        },
        "independent": {
          "ref": "Zohar, Emor 24:111-25:123",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Emor%2024%3A111-25%3A123?context=0",
          "hebrewTextSha256": "91cd98548a2c063db9e2abaf0542651f9c19a580d034c37c3907b3fcdbd99e48"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-18",
      "original": "בהאי יומא נייחא דעלאי ותתאי",
      "english": "On this day there is rest above and below.",
      "citation": "III 94b · Emor",
      "volume": "III",
      "folio": "94b",
      "parasha": "Emor",
      "topic": "menuchah",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ג_צד_ב",
          "retrievedAt": "2026-10-01T20:32:31.095Z",
          "documentSha256": "98de6b2e4a4bf413c77bf11d5ae093bec794ef18d345bf926bcd0aabf676d1fc"
        },
        "independent": {
          "ref": "Zohar, Emor 24:111-25:123",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Emor%2024%3A111-25%3A123?context=0",
          "hebrewTextSha256": "91cd98548a2c063db9e2abaf0542651f9c19a580d034c37c3907b3fcdbd99e48"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-19",
      "original": "האי יומא חדוותא דעלאי ותתאי כלא חדאן ביה",
      "english": "This day is the joy of those above and below; all rejoice in it.",
      "citation": "III 94b · Emor",
      "volume": "III",
      "folio": "94b",
      "parasha": "Emor",
      "topic": "joy",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ג_צד_ב",
          "retrievedAt": "2026-10-01T20:32:31.095Z",
          "documentSha256": "98de6b2e4a4bf413c77bf11d5ae093bec794ef18d345bf926bcd0aabf676d1fc"
        },
        "independent": {
          "ref": "Zohar, Emor 24:111-25:123",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Emor%2024%3A111-25%3A123?context=0",
          "hebrewTextSha256": "91cd98548a2c063db9e2abaf0542651f9c19a580d034c37c3907b3fcdbd99e48"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-20",
      "original": "לית עלמא קאים אלא על שלום",
      "english": "The world endures only through peace.",
      "citation": "III 176b · Korach",
      "volume": "III",
      "folio": "176b",
      "parasha": "Korach",
      "topic": "shalom",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ג_קעו_ב",
          "retrievedAt": "2026-10-01T20:32:31.393Z",
          "documentSha256": "7f39908a6e8b5354e14ba4c3e8d3a7c4263f764da0cef4d9b60974403f51f5ab"
        },
        "independent": {
          "ref": "Zohar, Korach 1:5-4:15",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Korach%201%3A5-4%3A15?context=0",
          "hebrewTextSha256": "fe92b02236319453b30d22c89cca4ffbd5c5a1a3336cea731e459bfe87512e69"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-21",
      "original": "שבת דאיהו שלמא דעלאי ותתאי, וכדין אתקיים עלמא",
      "english": "Shabbat is the peace of those above and below; then the world endures.",
      "citation": "III 176b · Korach",
      "volume": "III",
      "folio": "176b",
      "parasha": "Korach",
      "topic": "Shabbat peace",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ג_קעו_ב",
          "retrievedAt": "2026-10-01T20:32:31.393Z",
          "documentSha256": "7f39908a6e8b5354e14ba4c3e8d3a7c4263f764da0cef4d9b60974403f51f5ab"
        },
        "independent": {
          "ref": "Zohar, Korach 1:5-4:15",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Korach%201%3A5-4%3A15?context=0",
          "hebrewTextSha256": "fe92b02236319453b30d22c89cca4ffbd5c5a1a3336cea731e459bfe87512e69"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    },
    {
      "id": "zohar-shabbat-22",
      "original": "כד מפקין ספר תורה בצבורא למקרא ביה - מתפתחן תרעי שמייא דרחמין ומעוררין את האהבה לעילא",
      "english": "When the Torah scroll is brought out for public reading, heaven’s gates of mercy open, and love is awakened above.",
      "citation": "II 206a · Vayakhel",
      "volume": "II",
      "folio": "206a",
      "parasha": "Vayakhel",
      "topic": "Shabbat Torah reading",
      "context": "",
      "provenance": {
        "primary": {
          "url": "https://he.wikisource.org/wiki/זהר_חלק_ב_רו_א",
          "retrievedAt": "2026-10-01T20:32:30.848Z",
          "documentSha256": "a63b148d807d100ed2d50545b0a9c53b566ccce85492f1b9a6a43967c61a6aae"
        },
        "independent": {
          "ref": "Zohar, Vayakhel 17:218-227",
          "url": "https://www.sefaria.org/api/texts/Zohar%2C%20Vayakhel%2017%3A218-227?context=0",
          "hebrewTextSha256": "549fa85a04bb1376e0df1b32552df367e7415d50cd76b390980730fd734333ae"
        },
        "verification": "Exact original-language excerpt in the primary folio; independently matched, ignoring punctuation and vowel marks, in Sefaria’s Daf-mapped Aramaic text.",
        "translation": "Original concise English translation from the verified Aramaic; not a quotation from a modern published English edition."
      }
    }
  ]
}
